export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12848.6dee69cf.jpg";